import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { isAxiosError } from 'axios';
import { artifactQuery } from '@/features/artifacts/queries';
import { artifactSearchSchema } from '@/features/artifacts/constants';
import { ArtifactNotFound } from '@/features/artifacts/components/artifact-not-found';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId',
)({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient
      .query({
        ...artifactQuery(params.artifactId),
        staleTime: 'static',
      })
      .catch((error) => {
        if (isAxiosError(error) && error.response?.status === 404) throw notFound();
        throw error;
      }),
  notFoundComponent: ArtifactNotFound,
  validateSearch: artifactSearchSchema,
});

function RouteComponent() {
  return (
    <div className="flex grow min-h-0">
      <div className="relative grow flex flex-col min-w-0 min-h-0">
        <Outlet />
      </div>
    </div>
  );
}
